import Collection from '@/store/models/collections/Collection'

/**
 * Preserves existing pinPosition values from the Vuex ORM store before insertOrUpdate.
 * Prevents the regular collections endpoint (which returns pinPosition: null) from
 * overwriting correct pinPosition values set by the getMixedPinned endpoint.
 */
export function preserveCollectionPinPositions(items) {
  const list = Array.isArray(items) ? items : [items]
  for (const item of list) {
    const id = item._id || item.id
    if (!id) continue
    const existing = Collection.find(id)
    if (existing?.pinPosition != null) {
      item.pinPosition = existing.pinPosition
    }
  }
}
